import React from 'react';
import { FlightTicketPropType } from '../../../../PropTypes';
import { Form, Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { DATE_FORMAT_WEB } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';

const PersonalInfoSection = ({ flyToWorkTicketInfo }) => (
  <>
    <Row>
      <Form.Group as={Col}>
        <Form.Label>First Name</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.firstName || ''} disabled />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Last Name</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.lastName || ''} disabled />
      </Form.Group>
    </Row>
    <Row>
      <Form.Group as={Col}>
        <Form.Label>Date of birth </Form.Label>
        <Datetime
          timeFormat={false}
          dateFormat={DATE_FORMAT_WEB}
          closeOnSelect
          utc={true}
          inputProps={{ placeholder: DATE_FORMAT_WEB, disabled: true }}
          value={DateTimeFormater(flyToWorkTicketInfo.dateOfBirth, null, DATE_FORMAT_WEB)}
        />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Phone</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.phone || ''} disabled />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Gender</Form.Label>
        <Form.Control type="text" value={flyToWorkTicketInfo.gender || 'Not specified'} disabled />
      </Form.Group>
    </Row>
  </>
);

PersonalInfoSection.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
};

export default React.memo(PersonalInfoSection);
